import { render } from "./DataTableRow.vue?vue&type=template&id=a4242576&scoped=true&ts=true"
import script from "./DataTableRow.vue?vue&type=script&lang=ts"
export * from "./DataTableRow.vue?vue&type=script&lang=ts"

import "./DataTableRow.vue?vue&type=style&index=0&id=a4242576&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4242576"]])

export default __exports__